import AjaxService from '../services/ajax-service';

export const createSource = source => {
    return AjaxService({
        method: 'post',
        url: `users/me/sources`,
        data: { source }
    }, true).then(response => response.data);
}

export const fetchSources = () => {
    return AjaxService({
        method: 'get',
        url: `users/me/sources`
    }, true).then(response => response.data);
}

export const removeSource = sourceId => {
    return AjaxService({
        method: 'delete',
        url: `users/me/sources/${sourceId}`
    }, true).then(response => response.data);
}

export const getTaxForZip = (country_code, zip) => {
    return AjaxService({
        method: 'get',
        url: `billing/tax`,
        params: {
            zip,
            country_code
        }
    }).then(response => response.data);
}

export const getProratedInfo = plan => {
    return AjaxService({
        method: 'get',
        url: `billing/info`,
        params: { plan }
    }).then(response => response.data);
}

export const getCoupon = coupon => {
    return AjaxService({
        method: 'get',
        url: `billing/coupons/${coupon}`
    }).then(response => response.data);
}

export const fetchHistory = () => {
    return AjaxService({
        method: 'get',
        url: `billing/history`
    }).then(response => response.data.invoices);
}

export const addFeature = (feature, period) => {
    return AjaxService({
        method: 'put',
        url: `billing/features`,
        data: {
            feature,
            period
        }
    }).then(response => response.data);
}

export const removeFeature = feature => {
    return AjaxService({
        method: 'delete',
        url: `billing/features`,
        data: {
            feature
        }
    }).then(response => response.data);
}

export const sumoUpgrade = code => {
    return AjaxService({
        method: 'post',
        url: `sumo/submit`,
        data: {
            code
        }
    }).then(response => response.data);
}

export const sumoVerify = code => {
    return AjaxService({
        method: 'post',
        url: `sumo/verify`,
        data: {
            code
        }
    }, true).then(response => response.data);
}
